/**
 * Read at the moment of the interaction rather than through a hook: the answer is only needed
 * when an animation is about to start, and a subscription would cost a render per component.
 */
export function prefersReducedMotion(): boolean {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
